/** @format */

export const getPaddingRight = (hasOnClear: boolean) => {
    return hasOnClear ? '4.4rem' : '1.2rem';
};

export const getPaddingLeft = (hasPrefixIcon: boolean) => {
    return hasPrefixIcon ? '4.4rem' : '1.2rem';
};
